import { render, staticRenderFns } from "./PrivacyPolicyBR.vue?vue&type=template&id=0d124030&"
import script from "./PrivacyPolicyBR.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyBR.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyBR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports